import { createSlice } from '@reduxjs/toolkit'
import {
  mailConfigAction,
  settingMailConfigAction,
} from './mail.action'

const initialState: Mail.MailState = {
  isLoading: false,
  error: null,
  mailConfig: null,
}

const { actions, reducer } = createSlice({
  name: 'mail',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(mailConfigAction.pending, (state, action) => {
        state.isLoading = true
      })
      .addCase(mailConfigAction.fulfilled, (state, action) => {
        state.isLoading = false
        state.mailConfig = action.payload
      })
      .addCase(mailConfigAction.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error
      })

      .addCase(settingMailConfigAction.pending, (state, action) => {
        state.isLoading = true
      })
      .addCase(settingMailConfigAction.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(settingMailConfigAction.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error
      })
  },
})

export { reducer }
export default actions
